module.exports = __webpack_public_path__ + "img/best-friend.e833f76a.png";